import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { RegionalPagesPath, regionalPagesProps } from 'regions/runtime-components/pages-props'

import { NewLPScreen } from '../../../screens/new-lp'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const LoanPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	NewLPScreen({
		ratePoints: [
			'Ставка от 14,9% годовых',
			'Без подтверждения дохода',
			'Одобрение за 30 минут',
			'Никаких брокерских комиссий',
			'Без поручителей',
			'Все расходы по сделке — на нас',
		],
		mainBlockPath: {
			subtitle: 'Займы от 500 тысяч рублей',
		},
		minLoan: 5e5,
		hideOffers: true,
		leadProductType: 'REAL_ESTATE_LOAN',
		applicationFormTitle: 'Заявка на кредит',
		applicationFormProgressTitle: 'Вероятность одобрения кредита',
	})

LoanPage.layout = regionalPagesProps[RegionalPagesPath.loan].layout
LoanPage.layoutProps = regionalPagesProps[RegionalPagesPath.loan].layoutProps

LoanPage.headProps = regionalPagesProps[RegionalPagesPath.loan].headProps

export const getServerSideProps = serverSideResolveCity

export default LoanPage
